import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { MenuPermissionService } from '../../services/menu-permission.service';
import { isKnownAppRoute } from '../../constants/menu-route-access.constant';

export const menuAccessGuard: CanActivateChildFn = (childRoute, state) => {
  const permissionService = inject(MenuPermissionService);
  const router = inject(Router);

  if (childRoute.data?.['skipMenuGuard']) {
    return true;
  }

  const targetPath = state.url.split('?')[0];

  return permissionService.loadUserMenus().pipe(
    map(() => {
      if (!isKnownAppRoute(targetPath)) {
        return router.createUrlTree(['/access-denied'], {
          queryParams: { reason: 'not-found', from: targetPath },
        });
      }

      if (!permissionService.canAccessRoute(targetPath)) {
        const fallbackRoute = permissionService.getDefaultLandingRoute();
        if (
          targetPath === '/dashboard' &&
          fallbackRoute !== '/access-denied' &&
          permissionService.canAccessRoute(fallbackRoute)
        ) {
          return router.createUrlTree([fallbackRoute]);
        }

        return router.createUrlTree(['/access-denied'], {
          queryParams: { reason: 'forbidden', from: targetPath },
        });
      }

      return true;
    }),
  );
};
